import { forwardRef, PropsWithChildren, memo } from 'react';

import {
  TextProps as MantineTextProps,
  Text as MantineText,
  MantineColor,
  useMantineColorScheme
} from '@mantine/core';

interface TextProps extends MantineTextProps {
  darkColor?: MantineColor;
  lightColor?: MantineColor;
}

const Text = memo(
  forwardRef<
    HTMLSpanElement,
    PropsWithChildren<
      TextProps & {
        component?: any;
        href?: string;
        onClick?: () => void;
      }
    >
  >(({ children, c, darkColor, lightColor, component = 'span', ...rest }, ref) => {
    const theme = useMantineColorScheme();
    let finalColor = c;
    finalColor =
      theme.colorScheme === 'light'
        ? lightColor
          ? lightColor
          : c
        : darkColor
        ? darkColor
        : c;
    return (
      <MantineText
        {...rest}
        component={component}
        c={finalColor}
        fw={rest.fw}
        ref={ref}
      >
        {children}
      </MantineText>
    );
  })
);

export { Text };
export type { TextProps };
